import emojiData from 'emoji-datasource/emoji.json';

export const EMOJI_RECENTS_STORAGE_KEY = 'onlystruggles:recent-emojis';
export const EMOJI_RECENTS_MAX = 24;
export const DEFAULT_EMOJI_CATEGORY = 'Smileys';

export type EmojiCategory = {
    label: string;
    emojis: string[];
};

type EmojiDataItem = {
    unified: string;
    category: string;
    sort_order: number;
    has_img_apple: boolean;
};

const SOURCE_CATEGORY_LABELS: Record<string, string> = {
    'Smileys & Emotion': 'Smileys',
    'People & Body': 'People',
    'Animals & Nature': 'Nature',
    'Food & Drink': 'Food',
    Activities: 'Activities',
    'Travel & Places': 'Travel',
    Objects: 'Objects',
    Symbols: 'Symbols',
    Flags: 'Flags',
};

const SOURCE_CATEGORY_ORDER = [
    'Smileys & Emotion',
    'People & Body',
    'Animals & Nature',
    'Food & Drink',
    'Activities',
    'Travel & Places',
    'Objects',
    'Symbols',
    'Flags',
] as const;

export const EMOJI_CATEGORY_TAB_ICONS: Record<string, string> = {
    Recent: '🕘',
    Smileys: '😀',
    People: '🧑',
    Nature: '🌿',
    Food: '🍔',
    Activities: '⚽',
    Travel: '✈️',
    Objects: '💡',
    Symbols: '❤️',
    Flags: '🏳️',
};

const unifiedToEmoji = (unified: string): string =>
    String.fromCodePoint(...unified.split('-').map((part) => Number.parseInt(part, 16)));

export const FULL_EMOJI_CATEGORY_MAP: EmojiCategory[] = Object.entries(
    (emojiData as EmojiDataItem[]).reduce<Record<string, Array<{ emoji: string; order: number; sourceCategory: string }>>>((acc, entry) => {
        if (!entry.has_img_apple) return acc;
        const label = SOURCE_CATEGORY_LABELS[entry.category];
        if (!label) return acc;

        const emoji = unifiedToEmoji(entry.unified);
        if (!acc[label]) {
            acc[label] = [];
        }
        acc[label].push({ emoji, order: entry.sort_order, sourceCategory: entry.category });
        return acc;
    }, {}),
)
    .sort(([, leftItems], [, rightItems]) => {
        const leftSource = leftItems[0]?.sourceCategory;
        const rightSource = rightItems[0]?.sourceCategory;
        const leftIndex = SOURCE_CATEGORY_ORDER.indexOf(leftSource as typeof SOURCE_CATEGORY_ORDER[number]);
        const rightIndex = SOURCE_CATEGORY_ORDER.indexOf(rightSource as typeof SOURCE_CATEGORY_ORDER[number]);
        const normalizedLeftIndex = leftIndex === -1 ? Number.MAX_SAFE_INTEGER : leftIndex;
        const normalizedRightIndex = rightIndex === -1 ? Number.MAX_SAFE_INTEGER : rightIndex;
        return normalizedLeftIndex - normalizedRightIndex;
    })
    .map(([label, weighted]) => ({
        label,
        emojis: Array.from(new Set(weighted.sort((a, b) => a.order - b.order).map((item) => item.emoji))),
    }));
